import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PolicyResearchPaperArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-335.000000, -46.000000)"
      >
        <g transform="translate(335.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.716 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.716 -0.0001,15"
            fill="#FF4D52"
          />
          <path
            d="M10.9999,22.3515 C10.9999,22.8625 11.4179,23.2805 11.9279,23.2805 L22.3459,23.2805 C22.8559,23.2805 23.2739,22.8625 23.2739,22.3515 L23.2739,11.0815 C23.2739,10.5715 22.9909,9.8465 22.6449,9.4715 L20.5489,7.1995 C20.2029,6.8245 19.5019,6.5175 18.9919,6.5175 L11.9279,6.5175 C11.4179,6.5175 10.9999,6.9345 10.9999,7.4455 L10.9999,22.3515 Z"
            fill="#ffffff"
            className={styles.white}
          />
          <polyline
            points="19.9198 6.5175 19.9198 10.1635 23.2738 10.1545"
            stroke="#FF4D52"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <line
            stroke="#FF4D52"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="13.6444"
            x2="20.4054"
            y1="11.8183"
            y2="11.8183"
          />
          <line
            stroke="#FF4D52"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="13.6444"
            x2="20.4054"
            y1="15.5947"
            y2="15.5947"
          />
          <line
            stroke="#FF4D52"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="13.6444"
            x2="20.6444"
            y1="17.4404"
            y2="17.4404"
          />
          <line
            stroke="#FF4D52"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="13.6444"
            x2="20.4054"
            y1="13.7011"
            y2="13.7011"
          />
          <path
            d="M8.2489,14.6914 C8.2489,17.0034 10.1239,18.8774 12.4359,18.8774 C14.7469,18.8774 16.6219,17.0034 16.6219,14.6914 C16.6219,12.3784 14.7469,10.5044 12.4359,10.5044 C10.1239,10.5044 8.2489,12.3784 8.2489,14.6914 Z"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
          />
          <line
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeWidth="2"
            x1="9.0541"
            x2="5.8931"
            y1="18.5986"
            y2="21.7536"
          />
          <path
            d="M10.9994,18.624 C11.4474,18.788 11.9314,18.877 12.4354,18.877 C14.7474,18.877 16.6214,17.003 16.6214,14.691 C16.6214,12.379 14.7474,10.505 12.4354,10.505 C11.9314,10.505 11.4474,10.594 10.9994,10.758"
            stroke="#FF4D52"
          />
        </g>
      </g>
    </Icon>
  )
}
